import { useTranslation } from "react-i18next";
import MillimetreCubed from "../../../../../../components/Math/Units/Metric/MillimetreCubed";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Widerstandsmoment({ widerstandsmoment }) {
  const { t } = useTranslation("translation");
  const W_s_Formula = `\\displaystyle W_{s} = \\frac{\\pi}{32}\\cdot\\frac{\\left( D_{a,cal}^4-D_{i}^4\\right)}{D_{a,cal}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.sectionModulus")}</p>}
      indicesValue={
        <span>
          W<sub>s</sub>
        </span>
      }
      formulaValue={<ToolTip id={"W_s_Formula"} type={IconType.FORMULA} formula={W_s_Formula} />}
      inputValue={
        <span className="input">
          <NumberFormatText value={widerstandsmoment} decimalScale={0} />
        </span>
      }
      unitValue={<MillimetreCubed />}
    />
  );
}

export default Widerstandsmoment;
